import {
  useRive,
  Layout,
  Fit,
  Alignment,
  useViewModelInstanceBoolean,
  useViewModelInstanceEnum,
} from '@rive-app/react-webgl2';
import builtTriangleAnimated from '../../../source/images/homepage/built_triangle.riv';
import { useEffect } from 'react';
import React from 'react'

const TriangleAnimation = ({ inView, sectionSelection }) => {
  const { rive, RiveComponent } = useRive({
    // Load a local riv `clean_the_car.riv` or upload your own!
    src: builtTriangleAnimated,
    // Be sure to specify the correct state machine (or animation) name
    stateMachines: 'State Machine 1',
    // This is optional.Provides additional layout control.
    layout: new Layout({
      fit: Fit.Contain, // Change to: rive.Fit.Contain, or Cover
      alignment: Alignment.Center,
    }),
    autoplay: true,
    autoBind: true,
  });

  const vmi = rive?.viewModelInstance;

  const { setValue: setHasEnteredView } = useViewModelInstanceBoolean(
    'hasEnteredView', // Property path
    vmi
  );

  const { setValue: setSection } = useViewModelInstanceEnum(
    'section', // Property path
    vmi
  );

  useEffect(() => {
    setHasEnteredView(inView);
    setSection(sectionSelection);
  }, [inView, sectionSelection, setHasEnteredView, setSection]);

  return (
    <div className="w-[300px] h-[300px] lg:w-[400px] lg:h-[400px]">
      <RiveComponent />
    </div>
  );
};

export { TriangleAnimation };
